import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=f8e1ac1c&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=f8e1ac1c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8e1ac1c')) {
      api.createRecord('f8e1ac1c', component.options)
    } else {
      api.reload('f8e1ac1c', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=f8e1ac1c&", function () {
      api.rerender('f8e1ac1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accomodation/Form.vue"
export default component.exports